import React from 'react'
import Header from '../../headerone/Main'
import Bredcom from '../../Bredcom/Main'
import GalleryShowcase from './GalleryShowcase'

function Main() {
  return (
    <>
        <Header/>
        <Bredcom title="Home" subtitle="Our Gallery"/>
        <GalleryShowcase/>
    </>
  )
}

export default Main